var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOracleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 20",
    fill: "transparent",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2a8 8 0 100 16h12a8 8 0 000-16H10z",
    stroke: "#C74634",
    strokeWidth: 4
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAzMiAyMCIgZmlsbD0idHJhbnNwYXJlbnQiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMTAgMkM3Ljg3ODI3IDIgNS44NDM0NCAyLjg0Mjg1IDQuMzQzMTUgNC4zNDMxNUMyLjg0Mjg1IDUuODQzNDQgMiA3Ljg3ODI3IDIgMTBDMiAxMi4xMjE3IDIuODQyODUgMTQuMTU2NiA0LjM0MzE1IDE1LjY1NjlDNS44NDM0NCAxNy4xNTcxIDcuODc4MjcgMTggMTAgMThIMjJDMjQuMTIxNyAxOCAyNi4xNTY2IDE3LjE1NzEgMjcuNjU2OSAxNS42NTY5QzI5LjE1NzEgMTQuMTU2NiAzMCAxMi4xMjE3IDMwIDEwQzMwIDcuODc4MjcgMjkuMTU3MSA1Ljg0MzQ0IDI3LjY1NjkgNC4zNDMxNUMyNi4xNTY2IDIuODQyODUgMjQuMTIxNyAyIDIyIDJIMTBaIiBzdHJva2U9IiNDNzQ2MzQiIHN0cm9rZS13aWR0aD0iNCIvPgo8L3N2Zz4K";
export { SvgOracleLogo as ReactComponent };